import React, { Component } from "react";
import cn from "classnames";
import { FormattedMessage } from "react-intl";

import { setItem } from "../../cookie";

import { Cookie, Container, Text } from "./styles";
import messages from "./messages";

class Contact extends Component {
    state = {
        closed: false,
    };
    accept = () => {
        setItem("cookie-accepted", "true", 60 * 60 * 24 * 365);
        this.setState({ closed: true });
    };
    render() {
        const { closed } = this.state;
        return (
            <Cookie className={cn(closed && "CookieClosed")}>
                <Container>
                    <Text>
                        <FormattedMessage {...messages.text} />
                    </Text>
                    <button className="button" onClick={this.accept}>
                        <FormattedMessage {...messages.okay} />
                    </button>
                </Container>
            </Cookie>
        );
    }
}

export default Contact;
